import { handleActions } from "redux-actions";

import {
    getBrandTrackedDomains,
    getBrandTrackedDomainsSuccess,
    getBrandTrackedDomainsError,
    setBrandTrackedDomainsByBrandCode,
} from "modules/Brands/services/BrandTrackedDomains/actions";

const initialState = {
    isLoading: false,
    count: 0,
    brandTrackedDomains: [],
    brandTrackedDomainsByBrandCode: [],
};

export const brandTrackedDomainReducer = handleActions(
    {
        [getBrandTrackedDomains]: (state) => ({
            ...state,
            brandTrackedDomains: [],
            isLoading: true
        }),
        [getBrandTrackedDomainsSuccess]: (state, { payload }) => ({
            ...state,
            isLoading: false,
            ...payload
        }),
        [getBrandTrackedDomainsError]: (state) => ({
            ...state,
            isLoading: false
        }),
        [setBrandTrackedDomainsByBrandCode]: (state, { payload }) => ({
            ...state,
            brandTrackedDomainsByBrandCode: {
                ...state.brandTrackedDomainsByBrandCode,
                ...payload
            }
        }),
    },
    initialState
);
